var _regeneratorRuntime = require("D:\\wamp64\\www\\greenzeen\\greenzine-app-viewer\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

!function (e, t) {
  for (var r in t) {
    e[r] = t[r];
  }
}(exports, function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var i = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var i in e) {
      r.d(n, i, function (t) {
        return e[t];
      }.bind(null, i));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 21);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("@material-ui/core");
}, function (e, t, r) {
  "use strict";

  function n(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function i(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? n(Object(r), !0).forEach(function (t) {
        o(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function o(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  r.d(t, "a", function () {
    return l;
  });
  var a = {
    api: {
      url: "",
      key: ""
    },
    tenant: "",
    debug: !0
  },
      l = {
    configure: function configure(e) {
      a = i(i({}, a), e);
    },

    get config() {
      return a;
    }

  };
}, function (e, t) {
  e.exports = require("@apollo/client");
}, function (e, t) {
  e.exports = require("@material-ui/icons/Description");
}, function (e, t, r) {
  "use strict";

  r.d(t, "a", function () {
    return ie;
  });
  var n = r(0),
      i = r.n(n),
      o = r(7),
      a = r.n(o),
      l = r(12),
      c = r.n(l),
      u = r(13),
      f = r.n(u),
      s = r(2),
      m = r(3),
      p = r(14),
      b = r(15);

  function d() {
    var e = function (e, t) {
      t || (t = e.slice(0));
      return Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }(["\n        ", "\n      "]);

    return d = function d() {
      return e;
    }, e;
  }

  function y(e, t, r, n, i, o, a) {
    try {
      var l = e[o](a),
          c = l.value;
    } catch (e) {
      return void r(e);
    }

    l.done ? t(c) : Promise.resolve(c).then(n, i);
  }

  function g(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function v(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function h(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? v(Object(r), !0).forEach(function (t) {
        O(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : v(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function O(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var j = function () {
    function e() {
      var t = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), O(this, "_client", void 0), O(this, "query", function () {
        var e,
            r = (e = _regeneratorRuntime.mark(function e(r, n) {
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return "string" == typeof r && (r = Object(m.gql)(d(), r)), e.next = 3, t.client.query({
                    query: r,
                    variables: n
                  });

                case 3:
                  return e.abrupt("return", e.sent);

                case 4:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }), function () {
          var t = this,
              r = arguments;
          return new Promise(function (n, i) {
            var o = e.apply(t, r);

            function a(e) {
              y(o, n, i, a, l, "next", e);
            }

            function l(e) {
              y(o, n, i, a, l, "throw", e);
            }

            a(void 0);
          });
        });
        return function (e, t) {
          return r.apply(this, arguments);
        };
      }());
    }

    var t, r, n;
    return t = e, (r = [{
      key: "client",
      get: function get() {
        var e, t, r, n;
        return this._client || (this._client = (e = s.a.config.api.url, t = s.a.config.api.key, r = Object(p.setContext)(function (e, r) {
          return {
            headers: h(h({}, r.headers), {}, {
              "x-api-key": t
            })
          };
        }), n = new m.HttpLink({
          fetch: b.fetch,
          uri: e
        }), new m.ApolloClient({
          link: r.concat(n),
          cache: new m.InMemoryCache()
        }))), this._client;
      }
    }]) && g(t.prototype, r), n && g(t, n), e;
  }();

  function w() {
    var e = function (e, t) {
      t || (t = e.slice(0));
      return Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }(["\n  query listMedia($clientName: String!, $prefix: String, $limit: Int, $nextResultsToken: String) {\n    listMedia(\n      clientName: $clientName\n      prefix: $prefix\n      limit: $limit\n      nextResultsToken: $nextResultsToken\n    ) {\n      clientName\n      prefix\n      count\n      limit\n      nextResultsToken\n      media {\n        key\n        lastModified\n        eTag\n        size\n        storageClass\n        href\n        owner {\n          ID\n          displayName\n        }\n      }\n    }\n  }\n"]);

    return w = function w() {
      return e;
    }, e;
  }

  var E = Object(m.gql)(w());

  function S(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function x(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? S(Object(r), !0).forEach(function (t) {
        P(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function P(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function k(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, l = e[Symbol.iterator](); !(n = (a = l.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          n || null == l.return || l.return();
        } finally {
          if (i) throw o;
        }
      }

      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return C(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return C(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function C(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  var T = new j(),
      A = function A(e, t) {
    var r = k(Object(n.useState)({
      loading: !0,
      media: void 0,
      error: void 0
    }), 2),
        i = r[0],
        o = r[1];
    return Object(n.useEffect)(function () {
      T.query(E, {
        clientName: e,
        prefix: t,
        limit: 1e3,
        nextResultsToken: null
      }).then(function (t) {
        var r = {
          clientName: t.data.listMedia.clientName,
          prefix: t.data.listMedia.prefix,
          count: t.data.listMedia.count,
          media: t.data.listMedia.media.map(function (t) {
            return x(x({}, t), {}, {
              filename: t.key.replace(e + "/", "")
            });
          })
        };
        o({
          loading: !1,
          media: r,
          error: void 0
        });
      }).catch(function (e) {
        s.a.config.debug && console.error(e), o({
          loading: !1,
          media: void 0,
          error: e
        });
      });
    }, [e, t, 1e3, null]), i;
  },
      I = r(9),
      M = r.n(I),
      q = r(16),
      D = r.n(q),
      F = r(8),
      N = r.n(F),
      z = r(17),
      R = r.n(z),
      $ = r(18),
      B = r.n($),
      _ = function _(e) {
    return i.a.createElement(i.a.Fragment, null, i.a.createElement(N.a, {
      direction: "row",
      justify: "space-between",
      alignItems: "flex-start",
      container: !0
    }, i.a.createElement(N.a, {
      item: !0
    }, i.a.createElement("strong", null, "File Explorer")), i.a.createElement(N.a, {
      item: !0
    }, i.a.createElement(D.a, {
      size: "small"
    }, i.a.createElement(M.a, {
      onClick: function onClick(t) {
        e.changeView("list");
      }
    }, i.a.createElement(R.a, null)), i.a.createElement(M.a, {
      onClick: function onClick(t) {
        e.changeView("thumbnail");
      }
    }, i.a.createElement(B.a, null))), " ")));
  },
      H = {
    header: {},
    tableHeader: {
      col1: "",
      col2: "Filename",
      col3: "Size",
      col4: "Owner",
      col5: "Last Modified",
      col6: "Options"
    },
    table: {
      deleteConfirm: "Are you sure, you want to delete this file?",
      error: "Unable to load files from server, please try again"
    },
    thumbnail: {
      loadError: "Unable to load files from server, please try again"
    }
  },
      L = r(1);

  r(6), r(4);

  function U(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, l = e[Symbol.iterator](); !(n = (a = l.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          n || null == l.return || l.return();
        } finally {
          if (i) throw o;
        }
      }

      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return G(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return G(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function G(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  var V = [5, 10, 25, 50, 100],
      W = function W(e) {
    var t = e.media,
        r = U(n.useState(0), 2),
        i = r[0],
        o = r[1],
        a = U(n.useState(25), 2),
        l = a[0],
        c = a[1],
        u = U(n.useState(null), 2),
        f = u[0],
        s = u[1];
    return n.createElement(L.TableContainer, null, n.createElement(L.Table, {
      stickyHeader: !0,
      size: "small",
      "aria-label": "list of files"
    }, n.createElement(L.TableHead, null, n.createElement(L.TableRow, null, n.createElement(L.TableCell, {
      key: "selected",
      padding: "checkbox"
    }, n.createElement(L.Checkbox, {
      onChange: function onChange(e) {}
    })), n.createElement(L.TableCell, {
      key: "filename"
    }, n.createElement("strong", null, H.tableHeader.col2)), n.createElement(L.TableCell, {
      key: "size"
    }, n.createElement("strong", null, H.tableHeader.col3)), n.createElement(L.TableCell, {
      key: "lastModified"
    }, n.createElement("strong", null, H.tableHeader.col5)))), n.createElement(L.TableBody, null, t.media.slice(i * l, i * l + l).map(function (t, r) {
      var i,
          o = (i = t.key, f === i),
          a = "table-checkbox-".concat(r),
          l = t.filename,
          c = (t.owner, function (e) {
        e.toString();
        return e >= 1073741824 ? (e / 1073741824).toFixed(2) + " GB" : e >= 1048576 ? (e / 1048576).toFixed(2) + " MB" : e >= 1024 ? (e / 1024).toFixed(2) + " KB" : e > 1 ? e + " bytes" : 1 == e ? e + " byte" : "0 bytes";
      }(t.size)),
          u = new Date(t.lastModified).toLocaleString();
      return n.createElement(L.TableRow, {
        key: t.key,
        hover: !0,
        onClick: function onClick(r) {
          return function (t, r) {
            s(r && r.key), e.onSelect && e.onSelect(r);
          }(0, t);
        },
        selected: o,
        tabIndex: -1
      }, n.createElement(L.TableCell, {
        key: "selected",
        padding: "checkbox",
        align: "left"
      }, n.createElement(L.Checkbox, {
        checked: o,
        inputProps: {
          "aria-labelledby": a
        }
      })), n.createElement(L.TableCell, {
        key: "filename",
        align: "left"
      }, l), n.createElement(L.TableCell, {
        key: "size",
        align: "left"
      }, c), n.createElement(L.TableCell, {
        key: "lastModified",
        align: "left"
      }, u));
    }), t.count < 1 && n.createElement(L.TableRow, {
      key: "empty"
    }, n.createElement(L.TableCell, {
      colSpan: 6
    }))), n.createElement(L.TableFooter, null, n.createElement(L.TableRow, null, n.createElement(L.TablePagination, {
      count: t.count,
      rowsPerPageOptions: V,
      rowsPerPage: l,
      page: i,
      onChangePage: function onChangePage(e, t) {
        o(t);
      },
      onChangeRowsPerPage: function onChangeRowsPerPage(e) {
        c(parseInt(e.target.value, 10)), o(0);
      }
    })))));
  },
      K = r(19),
      J = r.n(K),
      Q = Object(L.makeStyles)(function (e) {
    return {
      root: {
        position: "relative",
        width: "100%",
        padding: "33% 0",
        backgroundImage: "url('https://thumbs.dreamstime.com/b/vector-empty-transparent-background-transparency-grid-seamless-pattern-171149540.jpg')",
        backgroundSize: "50%",
        backgroundPosition: "center",
        border: "2px solid rgba(255,255,255,0.8)",
        transition: "all 0.3s",
        "&:after": {
          content: "' '",
          position: "absolute",
          top: 0,
          left: 0,
          background: "rgb(0 173 255 / 0.4);",
          width: "100%",
          height: "100%",
          border: "2px solid rgb(0 173 255)",
          opacity: 0
        },
        "&:hover:after ": {
          opacity: .5
        }
      },
      image: {
        backgroundImage: "url('https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      selected: {
        "&:hover:after, &:after": {
          opacity: 1
        }
      }
    };
  }),
      X = function X(e) {
    var t = e.href,
        r = e.onClick,
        i = e.isSelected,
        o = Q(e),
        a = t.includes(".jpeg") || t.includes(".jpg") || t.includes(".png") || t.includes(".gif") || t.includes(".svg");
    return n.createElement("div", {
      className: J()(o.root, i && o.selected),
      onClick: r
    }, a && n.createElement("div", {
      className: o.image,
      style: {
        backgroundImage: "url('" + t + "')"
      }
    }));
  };

  function Y(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, l = e[Symbol.iterator](); !(n = (a = l.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          n || null == l.return || l.return();
        } finally {
          if (i) throw o;
        }
      }

      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Z(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Z(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function Z(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  var ee = [10, 25, 50, 100],
      te = function te(e) {
    var t = e.media,
        r = Y(n.useState(0), 2),
        i = r[0],
        o = r[1],
        a = Y(n.useState(50), 2),
        l = a[0],
        c = a[1],
        u = Y(n.useState(null), 2),
        f = u[0],
        s = u[1],
        m = t.media.slice(i * l, i * l + l);
    return n.createElement(n.Fragment, null, n.createElement(L.Grid, {
      container: !0,
      direction: "row",
      justify: "flex-start",
      alignItems: "flex-start",
      spacing: 1
    }, m.map(function (t, r) {
      return n.createElement(L.Grid, {
        item: !0,
        xs: 4,
        sm: 3,
        md: 2,
        lg: 2
      }, n.createElement(X, {
        isSelected: f === t.key,
        href: t.href,
        onClick: function onClick() {
          return function (t) {
            s(t && t.key), e.onSelect && e.onSelect(t);
          }(t);
        }
      }));
    })), n.createElement(L.TablePagination, {
      component: "div",
      count: t.count || 0,
      rowsPerPageOptions: ee,
      rowsPerPage: l,
      page: i,
      onChangePage: function onChangePage(e, t) {
        o(t);
      },
      onChangeRowsPerPage: function onChangeRowsPerPage(e) {
        c(parseInt(e.target.value, 10)), o(0);
      }
    }));
  };

  function re(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, l = e[Symbol.iterator](); !(n = (a = l.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          n || null == l.return || l.return();
        } finally {
          if (i) throw o;
        }
      }

      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return ne(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ne(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function ne(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  var ie = function ie(e) {
    var t = re(n.useState(e.view || "thumbnail"), 2),
        r = t[0],
        i = t[1],
        o = e.tenant || s.a.config.tenant,
        l = e.prefix || "",
        u = e.onSelect,
        m = A(o, l),
        p = m.loading,
        b = m.media,
        d = m.error;
    return n.createElement("div", null, n.createElement(_, {
      changeView: i,
      currentView: r
    }), n.createElement("br", null), p && n.createElement(a.a, {
      display: "flex"
    }, n.createElement(a.a, {
      m: "auto"
    }, n.createElement("br", null), n.createElement("br", null), n.createElement(c.a, null))), d && n.createElement(f.a, null, n.createElement(a.a, {
      m: "auto"
    }, n.createElement("br", null), n.createElement("br", null), d.toString())), !d && !p && "thumbnail" === r && n.createElement(te, {
      media: b,
      onSelect: u
    }), !d && !p && "list" === r && n.createElement(W, {
      media: b,
      onSelect: u
    }));
  };
}, function (e, t) {
  e.exports = require("@material-ui/icons/Folder");
}, function (e, t) {
  e.exports = require("@material-ui/core/Box");
}, function (e, t) {
  e.exports = require("@material-ui/core/Grid");
}, function (e, t) {
  e.exports = require("@material-ui/core/Button");
}, function (e, t) {}, function (e, t, r) {
  "use strict";

  r.d(t, "a", function () {
    return p;
  });
  var n = r(0),
      i = r(1),
      o = r(20),
      a = r(5);

  function l(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function c(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var u = function u(e) {
    return function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? l(Object(r), !0).forEach(function (t) {
          c(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }({
      eTag: "",
      filename: "",
      key: "",
      lastModified: "",
      owner: {},
      selected: "",
      size: 0,
      storageClass: "",
      href: ""
    }, e);
  };

  function f(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, l = e[Symbol.iterator](); !(n = (a = l.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          n || null == l.return || l.return();
        } finally {
          if (i) throw o;
        }
      }

      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return s(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return s(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function s(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  var m = Object(i.makeStyles)(function (e) {
    return {
      root: {
        padding: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: 400,
        border: "1px solid #ddd"
      },
      input: {
        marginLeft: e.spacing(1),
        flex: 1
      },
      iconButton: {
        padding: 10
      },
      divider: {
        height: 28,
        margin: 4
      },
      imageContainer: {
        position: "relative",
        width: "100%",
        maxWidth: 420,
        padding: "30% 0"
      },
      image: {
        position: "absolute",
        maxWidth: "100%",
        maxHeight: "100%",
        height: "auto",
        width: "auto",
        left: 0,
        top: 0
      }
    };
  }),
      p = function p(e) {
    var t = e.value,
        r = e.onChange,
        l = m(),
        c = f(n.useState(!1), 2),
        s = c[0],
        p = c[1],
        b = f(n.useState(null), 2),
        d = b[0],
        y = b[1];
    return n.createElement(n.Fragment, null, t && t.href && n.createElement("div", {
      className: l.imageContainer
    }, n.createElement("img", {
      src: t.href,
      className: l.image
    })), n.createElement(i.Paper, {
      className: l.root,
      elevation: 0
    }, n.createElement(i.InputBase, {
      value: t && t.href,
      className: l.input,
      placeholder: "Select image",
      inputProps: {
        "aria-label": "select image"
      },
      onChange: function (e) {
        function t(t) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e) {
        return r(u({
          href: e.target.value
        }));
      })
    }), n.createElement(i.Divider, {
      className: l.divider,
      orientation: "vertical"
    }), n.createElement(i.IconButton, {
      color: "primary",
      className: l.iconButton,
      "aria-label": "open file explorer",
      onClick: function onClick() {
        return p(!0);
      }
    }, n.createElement(o.Folder, null))), n.createElement(i.Dialog, {
      fullWidth: !0,
      maxWidth: "xl",
      open: s,
      onClose: function onClose() {
        return p(!1);
      }
    }, n.createElement(i.DialogTitle, null, "File Explorer"), n.createElement(i.DialogContent, null, n.createElement(a.a, {
      onSelect: function onSelect(e) {
        return y(e);
      }
    })), n.createElement(i.DialogActions, null, n.createElement(i.Button, {
      onClick: function onClick() {
        p(!1), r(d);
      }
    }, "Select"))));
  };
}, function (e, t) {
  e.exports = require("@material-ui/core/CircularProgress");
}, function (e, t) {
  e.exports = require("@material-ui/core/Container");
}, function (e, t) {
  e.exports = require("@apollo/client/link/context");
}, function (e, t) {
  e.exports = require("cross-fetch");
}, function (e, t) {
  e.exports = require("@material-ui/core/ButtonGroup");
}, function (e, t) {
  e.exports = require("@material-ui/icons/List");
}, function (e, t) {
  e.exports = require("@material-ui/icons/ViewModule");
}, function (e, t) {
  e.exports = require("classnames");
}, function (e, t) {
  e.exports = require("@material-ui/icons");
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(5);
  r.d(t, "FileExplorer", function () {
    return n.a;
  });
  var i = r(11);
  r.d(t, "FileSelector", function () {
    return i.a;
  });
  var o = r(2);
  r.d(t, "MediaLibrary", function () {
    return o.a;
  });
  var a = r(10);

  for (var l in a) {
    ["default", "FileExplorer", "FileSelector", "MediaLibrary"].indexOf(l) < 0 && function (e) {
      r.d(t, e, function () {
        return a[e];
      });
    }(l);
  }
}]));